var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.asthmaNodeComponent)?_c('keep-alive',[_c(_vm.asthmaNodeComponent,_vm._b({tag:"component",attrs:{"content":_vm.content}},'component',_vm.nodeData,false))],1):_c('div',[_vm._v("asthma form node not found")])
}
var staticRenderFns = []

export { render, staticRenderFns }